import script from "./ReportQCNotesModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReportQCNotesModal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__